module.exports = __webpack_public_path__ + "media/images/qr_code_poster_template1-05430eecba840fbb0c344e1829337964.png";